export default "__VITE_ASSET__Bzx4n14___"